import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Tabs,
  Tab,
  Container,
  Grid,
} from "@mui/material";
import Header from "@components/Header/Header";
import bgImage from "../../../assets/images/BG.svg";

const Login = () => {
  const [activeTab, setActiveTab] = useState("Individual");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="page-content">
        <Header />

        {/* Welcome Section */}
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Container maxWidth="sm">
            <Paper
              elevation={3}
              sx={{
                width: "472px",
                maxWidth: "100%",
                margin: "0 auto",
                borderRadius: "16px",
                padding: "32px",
                textAlign: "left",
                backgroundColor: "#fff",
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                sx={{ mb: 4 }}
              >
                Verify Details
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body1" fontWeight="bold">
                    Name
                  </Typography>
                  <Typography>Amit Singh</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" fontWeight="bold">
                    Date of Birth
                  </Typography>
                  <Typography>10/12/1988</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1" fontWeight="bold">
                    Mobile Number
                  </Typography>
                  <Typography>+91 98412 34567</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" fontWeight="bold">
                    E-mail ID
                  </Typography>
                  <Typography>amit.singh@gmail.com</Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body1" fontWeight="bold">
                    Address
                  </Typography>
                  <Typography>
                    No: 15 Town Planning Scheme Road, <br />
                    Lucknow, Uttar Pradesh - 226016
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body1" fontWeight="bold">
                    GST No.
                  </Typography>
                  <Typography>09AAACH7409R1ZZ</Typography>
                </Grid>
              </Grid>

              <Box textAlign="center" mt={4}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3A1C73",
                    borderRadius: "24px",
                    padding: "10px 40px",
                    fontWeight: 500,
                    textTransform: "none",
                    fontSize: "16px",
                    "&:hover": {
                      backgroundColor: "#2e004f",
                    },
                  }}
                >
                  Continue
                </Button>
              </Box>
            </Paper>
          </Container>
        </Box>
        {/* Main Box */}
      </div>
    </Box>
  );
};

export default Login;
